/**
 * Created by lvardarova on 29/04/16.
 */
import React from 'react';
import SvgIcon from '../../svgIcon/SvgIcon';

export function Shirts(props) {
    return (
        <SvgIcon {...props}>
            <path d="M8.144,2.309H7.267L6.338,1.469c0,0-0.36-0.469-1.344-0.469C4,1,3.683,1.469,3.683,1.469L2.8,2.309H1.855 L0,4.502v7.249h1.57V5.463h0.667v6.984C2.62,12.611,3.671,13,4.994,13c1.317,0,2.369-0.386,2.76-0.551V5.463h0.667v6.288H10 V4.502L8.144,2.309z M4.2,3.531L3.284,2.615l0.438-0.431l0.895,0.895L4.2,3.531z M5.333,11.859H4.666v-0.671h0.667V11.859z M5.333,8.671H4.666V8h0.667V8.671z M5.333,5.484H4.666V4.813h0.667V5.484z M5.8,3.526L5.394,3.079L6.31,2.156l0.423,0.433 L5.8,3.526z" />
        </SvgIcon>
    );
}

Shirts.defaultProps = {
    viewBox: '0 0 10 16'
};

export default Shirts;
